<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div style="float: right">
        <md-button class="md-success" @click="$router.push({ path: 'create-workshop' })">
          Create Workshop
        </md-button>
      </div>

      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>palette</md-icon>
          </div>
          <h4 class="title">Workshop List</h4>
        </md-card-header>

        <!-- ── Filters ── -->
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30">
              <md-field>
                <label>Search by Title</label>
                <md-input v-model="filters.search" type="text" @input="applyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-field>
                <label>Date From</label>
                <md-input v-model="filters.dateFrom" type="date" @change="applyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-field>
                <label>Date To</label>
                <md-input v-model="filters.dateTo" type="date" @change="applyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20" style="display:flex; align-items:center;">
              <md-button class="md-warning" @click="resetFilters">Reset Filters</md-button>
            </div>
          </div>
        </md-card-content>
        <!-- ── /Filters ── -->

        <md-card-content v-if="filteredData.length === 0">
          <h4>No data found.</h4>
        </md-card-content>

        <md-card-content v-else>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="md-container-custom paginated-table"
            table-header-color="green"
            md-fixed-header
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Title"      md-sort-by="title">{{ item.title }}</md-table-cell>
              <md-table-cell md-label="Date Time"  md-sort-by="date">{{ item.date }} | {{ item.time }}</md-table-cell>
              <md-table-cell md-label="Address"    md-sort-by="address">{{ item.address }}</md-table-cell>
              <md-table-cell md-label="Price"      md-sort-by="price">{{ item.price }}</md-table-cell>
              <md-table-cell md-label="Created On" md-sort-by="created_at">
                {{ HumanReadableDateFormat(item.created_at, true) }}
              </md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  class="md-just-icon md-warning md-simple"
                  title="Edit Workshop"
                  @click="$router.push({ path: 'update-workshop', query: { id: item._id } })"
                >
                  <md-icon>edit</md-icon>
                </md-button>&nbsp;&nbsp;
                <md-button
                  class="md-just-icon md-danger md-simple"
                  title="Delete Workshop"
                  @click="deleteWorkshop(item._id)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <md-card-actions md-alignment="space-between">
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </md-card-actions>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Pagination } from "@/components";
import WorkshopService from "../../../services/WorkshopService";

export default {
  components: { Pagination },
  computed: {
    // Filter tableData based on search + date range
    filteredData() {
      let result = this.tableData;

      if (this.filters.search.trim()) {
        const q = this.filters.search.trim().toLowerCase();
        result = result.filter((w) => w.title.toLowerCase().includes(q));
      }

      if (this.filters.dateFrom) {
        result = result.filter((w) => w.date >= this.filters.dateFrom);
      }

      if (this.filters.dateTo) {
        result = result.filter((w) => w.date <= this.filters.dateTo);
      }

      return result;
    },

    queriedData() {
      return this.filteredData.slice(this.from, this.to);
    },
    to() {
      const high = this.from + this.pagination.perPage;
      return this.total < high ? this.total : high;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.filteredData.length;
    },
  },
  data() {
    return {
      isDisabled: false,
      tableData: [],

      // Filters
      filters: {
        search:   "",
        dateFrom: "",
        dateTo:   "",
      },

      // Pagination
      searchedData: [],
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },

      // Sorting
      currentSort: "date",
      currentSortOrder: "asc",
    };
  },
  methods: {
    applyFilters() {
      // Reset to page 1 whenever filters change
      this.pagination.currentPage = 1;
    },

    resetFilters() {
      this.filters = { search: "", dateFrom: "", dateTo: "" };
      this.pagination.currentPage = 1;
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].toString().localeCompare(b[sortBy].toString());
        }
        return b[sortBy].toString().localeCompare(a[sortBy].toString());
      });
    },

    getWorkshops() {
      WorkshopService.getWorkshops()
        .then((response) => {
          this.tableData = response.data.data;
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    deleteWorkshop(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "Workshop data will be deleted.",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, Delete It!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          WorkshopService.deleteWorkshop({ id })
            .then((response) => {
              this.$toast.success(response.data.response_msg);
              this.getWorkshops();
            })
            .catch((e) => {
              this.$toast.error(e.response.data.respones_msg);
            });
        }
      });
    },
  },
  beforeMount() {
    this.getWorkshops();
  },
};
</script>